import styled from 'styled-components'
import { mq } from '../../../styles/vars/media-queries.style'

export const MapNavigation = styled.div`
  display: none;
  text-align: center;

  ${mq.desk} {
    display: block;
  }
`
